
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Types for our database tables
export interface Client {
  id: string;
  user_id: string;
  name: string;
  email: string;
  phone: string;
  state: string;
  purchase_price: string;
  broker: string;
  last_contact: string;
  client_state: string;
  date_created: string;
  created_at: string;
  updated_at: string;
}

export interface EmailTemplate {
  id: string;
  user_id: string;
  name: string;
  subject: string;
  body: string;
  broker?: string;
  created_at: string;
  updated_at: string;
}

export interface TextTemplate {
  id: string;
  user_id: string;
  name: string;
  body: string;
  broker?: string;
  created_at: string;
  updated_at: string;
}
